import { ISupportStaffRole } from './../models';
import axios, { AxiosResponse } from 'axios';

import { authFetch } from './fetch';

const baseUrl = '/api/Admin/SupportStaffRoles';

export const ISupportStaffAPI = {
  async getAll(): Promise<ISupportStaffRole[]> {
    try {
      const response: AxiosResponse<ISupportStaffRole[]> = await authFetch.get(baseUrl);

      if (!(response.status >= 200 && response.status < 300)) {
        throw Error(response.statusText);
      }

      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        throw Error(error?.response?.data);
      }
      throw error;
    }
  },

  async upsert(upsertData: ISupportStaffRole[]): Promise<ISupportStaffRole[]> {
    try {
      const response: AxiosResponse<ISupportStaffRole[]> = await authFetch.put(baseUrl, upsertData);

      if (!(response.status >= 200 && response.status < 300)) {
        throw Error(response.statusText);
      }

      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        throw Error(error?.response?.data);
      }
      throw error;
    }
  },

  async delete(supportStaffRoleId: number): Promise<void> {
    try {
      const response = await authFetch.delete(`${baseUrl}/${supportStaffRoleId}`);
      
      if (!(response.status >= 200 && response.status < 300)) {
        throw Error(response.statusText);
      }

      return;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        throw Error(error?.response?.data?.Detail);
      }
      throw error;
    }
  },
};
